import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';

import {
  SideNavigation,
  SideNavigationItem,
} from '../../components/SideNavigation';

export const FieldSessionsMenu = React.memo(
  ({ sessionId }: { sessionId?: string }) => {
    const location = useLocation();
    const overviewPath = sessionId
      ? `/field-sessions/${sessionId}`
      : '/field-sessions';
    const findsPath = sessionId ? `${overviewPath}/finds` : null;

    return (
      <SideNavigation>
        <SideNavigationItem isDefault to={`${overviewPath}${location.search}`}>
          {sessionId ? (
            <FormattedMessage
              id="fieldSessions.menu.overview"
              defaultMessage="Overview"
            />
          ) : (
            <FormattedMessage
              id="fieldSessions.menu.sessions"
              defaultMessage="Sessions"
            />
          )}
        </SideNavigationItem>
        {findsPath && (
          <SideNavigationItem to={`${findsPath}${location.search}`}>
            <FormattedMessage id="fieldSessions.finds" defaultMessage="Finds" />
          </SideNavigationItem>
        )}
      </SideNavigation>
    );
  }
);
